/**
 * Materiali per settore — finder + scrollspy (page-template/materials.php).
 *
 * Due responsabilità, entrambe auto-attivate solo se il markup esiste:
 *  1. Finder (.js-materials-finder): filtro istantaneo Settore × Famiglia +
 *     ricerca live sul grade, con highlight del match, contatore e CTA. I dati
 *     arrivano dal JSON serializzato in .js-materials-data (nessuna fetch).
 *  2. Nav card-settore (.js-materials-nav): scrollspy della barra sticky
 *     (IntersectionObserver) + smooth scroll al click, come src/js/process-nav.js.
 *
 * Rispetta prefers-reduced-motion.
 */
(function () {
	'use strict';

	var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	function esc(value) {
		return String(value).replace(/[&<>"]/g, function (c) {
			return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
		});
	}

	// --- 1. FINDER -----------------------------------------------------------
	var finder = document.querySelector('.js-materials-finder');
	if (finder) {
		initFinder(finder);
	}

	// --- 2. NAV scrollspy ----------------------------------------------------
	var nav = document.querySelector('.js-materials-nav');
	if (nav) {
		initNav(nav);
	}

	function initFinder(root) {
		var dataEl = root.querySelector('.js-materials-data');
		if (!dataEl) {
			return;
		}

		var data;
		try {
			data = JSON.parse(dataEl.textContent);
		} catch (err) {
			return;
		}

		var sectors = data.sectors || [];
		var elSector = root.querySelector('.js-materials-sector');
		var elFamily = root.querySelector('.js-materials-family');
		var elGrade = root.querySelector('.js-materials-grade');
		var elResults = root.querySelector('.js-materials-results');
		var elCount = root.querySelector('.js-materials-count');
		var elReset = root.querySelector('.js-materials-reset');

		if (!elResults) {
			return;
		}

		var initialHint = elResults.innerHTML; // ripristinato quando i filtri sono vuoti

		function highlight(text, q) {
			if (!q) {
				return esc(text);
			}
			var i = text.toLowerCase().indexOf(q);
			if (i < 0) {
				return esc(text);
			}
			return esc(text.slice(0, i)) + '<mark>' + esc(text.slice(i, i + q.length)) + '</mark>' + esc(text.slice(i + q.length));
		}

		function run() {
			var sSlug = elSector ? elSector.value : '';
			var fKey = elFamily ? elFamily.value : '';
			var raw = elGrade ? elGrade.value.trim() : '';
			var q = raw.toLowerCase();

			if (!sSlug && !fKey && !q) {
				elResults.innerHTML = initialHint;
				if (elCount) {
					elCount.textContent = '';
				}
				return;
			}

			var rows = [];
			sectors.forEach(function (s) {
				if (sSlug && s.slug !== sSlug) {
					return;
				}
				(s.families || []).forEach(function (f) {
					if (fKey && f.key !== fKey) {
						return;
					}
					var grades = f.grades || [];
					if (q) {
						grades = grades.filter(function (g) {
							return g.toLowerCase().indexOf(q) > -1;
						});
						if (!grades.length) {
							return;
						}
					}
					rows.push({ sector: s, fam: f, grades: grades });
				});
			});

			if (elCount) {
				elCount.innerHTML = '<b>' + rows.length + '</b> ' +
					(rows.length === 1 ? 'combinazione' : 'combinazioni') +
					' settore × materiale' + (q ? ' · grade “' + esc(raw) + '”' : '');
			}

			if (!rows.length) {
				elResults.innerHTML = '<div class="materials-results__empty"><b>Nessun grade a catalogo per questa ricerca.</b>Prova un altro codice — oppure inviaci la specifica: valutiamo anche materiali fuori standard.</div>';
				return;
			}

			var html = rows.slice(0, 60).map(function (r) {
				var grades = r.grades.map(function (g) {
					return '<li class="materials-grade">' + highlight(g, q) + '</li>';
				}).join('');
				return '<a class="materials-result" href="#settore-' + esc(r.sector.slug) + '">' +
					'<span class="materials-result__sector">' + esc(r.sector.name) + '</span>' +
					'<p class="materials-result__fam">' + esc(r.fam.name) + '</p>' +
					'<ul class="materials-grades">' + grades + '</ul></a>';
			}).join('');

			elResults.innerHTML = '<div class="materials-results__grid">' + html + '</div>';
		}

		[elSector, elFamily].forEach(function (el) {
			if (el) {
				el.addEventListener('change', run);
			}
		});
		if (elGrade) {
			elGrade.addEventListener('input', run);
		}
		if (elReset) {
			elReset.addEventListener('click', function () {
				if (elSector) { elSector.value = ''; }
				if (elFamily) { elFamily.value = ''; }
				if (elGrade) { elGrade.value = ''; }
				run();
				if (elGrade) { elGrade.focus(); }
			});
		}
	}

	function initNav(navEl) {
		var cards = Array.prototype.slice.call(navEl.querySelectorAll('.materials-nav__card'));
		if (!cards.length) {
			return;
		}

		var scroller = navEl.querySelector('.materials-nav__scroller') || navEl;

		function targetOf(card) {
			var href = card.getAttribute('href') || '';
			return href.charAt(0) === '#' ? document.getElementById(href.slice(1)) : null;
		}

		var sections = cards.map(targetOf).filter(Boolean);
		if (!sections.length) {
			return;
		}

		function centerCard(card) {
			var offset = card.offsetLeft - (scroller.clientWidth - card.offsetWidth) / 2;
			if (typeof scroller.scrollTo === 'function') {
				scroller.scrollTo({ left: offset, behavior: reduceMotion ? 'auto' : 'smooth' });
			} else {
				scroller.scrollLeft = offset;
			}
		}

		function setActive(id) {
			cards.forEach(function (card) {
				var active = card.getAttribute('href') === '#' + id;
				card.classList.toggle('is-active', active);
				if (active) {
					card.setAttribute('aria-current', 'true');
					centerCard(card);
				} else {
					card.removeAttribute('aria-current');
				}
			});
		}

		var observer = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						setActive(entry.target.id);
					}
				});
			},
			{ rootMargin: '-45% 0px -50% 0px', threshold: 0 }
		);

		sections.forEach(function (section) {
			observer.observe(section);
		});

		cards.forEach(function (card) {
			card.addEventListener('click', function (event) {
				var target = targetOf(card);
				if (!target) {
					return;
				}
				event.preventDefault();
				target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
				setActive(target.id);
				if (window.history && window.history.replaceState) {
					window.history.replaceState(null, '', card.getAttribute('href'));
				}
			});
		});
	}
})();
